import './instrument'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'
import { BrandProvider } from './contexts/BrandContext'
import ErrorBoundary from './components/ui/ErrorBoundary'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* The v7_startTransition and v7_relativeSplatPath opt-ins are the
          default behaviour in react-router 7, and the prop no longer exists. */}
      <BrowserRouter>
        <AuthProvider>
          <ToastProvider>
            <BrandProvider>
              <ErrorBoundary>
                <App />
              </ErrorBoundary>
            </BrandProvider>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
